import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _class2, _descriptor, _descriptor2, _descriptor3;
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AbErrorBoundary } from "abreact/incubator/ui/component/AbErrorBoundary";

/**
 * The properties for a layer root.
 */
export class LayerRootProps {}
/**
 * The layer root is responsible for rendering a layer manager's layers.
 */
export let LayerRoot = observer(_class = (_class2 = class LayerRoot extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const doc = this.props.layerGroup.layerRootElement.ownerDocument;
      doc?.defaultView.addEventListener("scroll", this.onScroll, true);
      doc?.addEventListener("mousedown", this.onCaptureMouseDown, true);
      doc?.addEventListener("click", this.onClick);
    });
    _defineProperty(this, "componentWillUnmount", () => {
      const doc = this.props.layerGroup.layerRootElement.ownerDocument;
      doc?.defaultView?.removeEventListener("scroll", this.onScroll, true);
      doc?.removeEventListener("mousedown", this.onCaptureMouseDown, true);
      doc?.removeEventListener("click", this.onClick);
    });
    _defineProperty(this, "eventHelper", (e, f) => {
      const targetId = this.getIdFromEvent(e);
      if (targetId === "kendo") {
        return;
      }
      for (let handle of this.props.layerGroup.layers.slice().reverse()) {
        if (handle.id === targetId) {
          return;
        }
        const eventHandlers = this.props.layerGroup.getEventHandlers(handle);
        if (f(eventHandlers)) {
          return;
        }
      }
    });
    _initializerDefineProperty(this, "onScroll", _descriptor, this);
    _initializerDefineProperty(this, "onCaptureMouseDown", _descriptor2, this);
    _initializerDefineProperty(this, "onClick", _descriptor3, this);
    // TODO: This should be refactored so that the ab-popup class is not relied upon
    _defineProperty(this, "getIdFromEvent", event => {
      const target = event.target;
      if (target.closest) {
        const containingPopup = target.closest(".ab-popup,.k-popup");
        if (containingPopup && containingPopup.className.indexOf("k-popup") >= 0) {
          return "kendo";
        }
        return containingPopup ? containingPopup.id : undefined;
      }
      return undefined;
    });
    makeObservable(this);
  }
  render() {
    const layers = this.props.layerGroup.layers;
    return /*#__PURE__*/React.createElement(React.Fragment, null, layers.map(layerHandle => {
      return /*#__PURE__*/React.createElement(AbErrorBoundary, {
        key: layerHandle.id,
        onError: () => this.props.layerGroup.remove(layerHandle)
      }, layerHandle.layerNode);
    }));
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "onScroll", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return e => {
      this.eventHelper(e, eventHandlers => {
        if (eventHandlers && eventHandlers.onBackgroundScroll) {
          return eventHandlers.onBackgroundScroll(e) === false; // If event handler returns false, stop bubbling.
        }
        return false;
      });
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "onCaptureMouseDown", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return e => {
      this.eventHelper(e, eventHandlers => {
        if (eventHandlers && eventHandlers.onBackgroundCaptureMouseDown) {
          return eventHandlers.onBackgroundCaptureMouseDown(e) === false; // If event handler returns false, stop bubbling.
        }
        return false;
      });
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "onClick", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return e => {
      this.eventHelper(e, eventHandlers => {
        if (eventHandlers && eventHandlers.onBackgroundClick) {
          return eventHandlers.onBackgroundClick(e) === false; // If event handler returns false, stop bubbling.
        }
        return false;
      });
    };
  }
}), _class2)) || _class;
//# sourceMappingURL=LayerRoot.js.map
